module.exports = __webpack_public_path__ + "static/media/7.d1a95428.jpg";